import React, { useState } from 'react';
import styles from './CardDetail.module.css';
import CheckoutButton from '../../../../Design/Button/Checkout/Checkout';
import CheckoutPage from '../../../../Functionality/Stripe/CheckoutPage';
//import LoginButton from '../../../../Design/Button/Login/LoginButton';

const CardDetail = ({ investment }) => { 
  // ✅ Always call hooks at the top level
  const [showCheckout, setShowCheckout] = useState(false);

  // ✅ Handle missing investment after hooks
  if (!investment) {
    return <div>Investment not found.</div>; 
  }

  // const squarePaymentLink = 'https://square.link/u/V5M1BcoF';

  return (
    <div className={ styles.investmentDetailContainer}>
      <div className={styles.investmentContent}>
        {/* Buy Box Section */}
        <div className={styles.buyBox}>
          <h3>EARLY BIRD TERMS</h3>
          <p><strong>{investment.amountRaised} LEFT</strong></p>
          <p>{investment.raisedAmount} raised from {investment.investorsCount} investors</p>
          
          <div className={styles.investmentProgress}>
            <p><strong>INVEST</strong></p>
            <p>$250 Minimum</p>
            
            {/* Checkout Button */}
            <CheckoutButton onClick={() => setShowCheckout(!showCheckout)} />
          </div>

          {/* Investor Terms */}
          <div className={styles.termsSection}>
            <div className={styles.termsHeader}>
              <strong>Investor Terms</strong>
            </div>
            <div className={styles.termsBody}>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam et arcu quis risus scelerisque sollicitudin. Suspendisse viverra nulla et magna tempor, eu consectetur arcu efficitur.</p>
            </div>
          </div>
        </div>

        <hr className={styles.divider} />
        
        {/* Investment Details */}
        <div>
          <h2>{investment.title}</h2>
          <img src={investment.image} alt={investment.title} className={styles.investmentImage} />
          <p>{investment.description}</p>
          <p>Tagline: {investment.tagline}</p>
          <p>Amount Raised: {investment.amountRaised}</p>
          <p>Valuation Cap: {investment.valuationCap}</p>
        </div>

        {/* Checkout Page (Shows when button is clicked) */}
        {showCheckout && <CheckoutPage />}
      </div>
    </div>
  );
};

export default CardDetail;
